module.exports = __webpack_public_path__ + "img/Financial_Advisor_880x660_DemoScreen_Avada.95fbf60a.jpg";